﻿import * as React from 'react';
import Grid from '@mui/material/Grid';
import CalendarBody from '../CalendarBody';
import CalendarHeader from '../CalendarHeader';
import { AuthenticatedUser } from '../../../../../shared/types';
import { Photographer, Region } from '../../BookingsCalendarTypes';
import { useQuery } from 'react-query';
import { CalendarBookingApi } from '../queries/CalendarBookingApi';
import CalendarLoading from '../CalendarLoading';

type CalendarWithAllPhotographersProps = {
    photographers: Photographer[];
    user: AuthenticatedUser;
    availableRegions: Region[];
};

type ExternalProps = {
    user: AuthenticatedUser;
};

function CalendarWithAllPhotographers({
    availableRegions,
    photographers,
    user
}: CalendarWithAllPhotographersProps) {
    let isAdvancedMode = false;
    let bookingInfo = null;
    let selectedOrder = null;

    let today = new Date(Date.now());
    let [selectedBookingDate, setSelectedBookingDate] = React.useState<Date>(today);

    function handleChangeBookingDate(newDate: Date) {
        setSelectedBookingDate(newDate);
    }

    return (
        <Grid
            item
            xs={12}
            md={8}
            sx={{
                paddingTop: '29px !important'
            }}
        >
            <CalendarHeader
                user={user}
                isAdvancedMode={isAdvancedMode}
                onChangeBookingDate={handleChangeBookingDate}
                selectedBookingDate={selectedBookingDate}
                availableRegions={availableRegions}
                selectedRegion={null}
                selectedOrder={selectedOrder}
                selectedProperties={[]}
                handleChangeSelectedProperties={() => {}}
                onAreaOrRegionChange={() => {}}
                shouldUseArea={false}
            />
            <CalendarBody
                bookingInfo={bookingInfo}
                isAdvancedMode={isAdvancedMode}
                selectedOrder={selectedOrder}
                photographers={photographers}
                onChangeBookingInfo={() => {}}
                hideTravelTimes={false} 
                onChangePhotographer={() => {}}
                selectedBookingDate={selectedBookingDate}
            />
        </Grid>
    );
}

export default function CalendarWithAllPhotographersDataLayer({ user }: ExternalProps) {
    const queryKey = 'all-photographers';
    let { isError, error, isLoading, data } = useQuery([queryKey], () =>
        CalendarBookingApi.getAllPhotographers()
    );

    if (isError) {
        console.error('Error fetching all photographers.', error);
    }

    if (isLoading) {
        return (
            <Grid
                item
                xs={12}
                md={8}
                sx={{
                    paddingTop: '29px !important'
                }}
            >
                <CalendarHeader
                    user={user}
                    shouldUseArea={false}
                    onAreaOrRegionChange={() => {}}
                    selectedBookingDate={new Date(Date.now())}
                    isAdvancedMode={false}
                    availableRegions={[]}
                    selectedRegion={null}
                    selectedOrder={null}
                    selectedProperties={[]}
                    handleChangeSelectedProperties={() => {}}
                />
                <CalendarLoading isAdvancedMode={false} />
            </Grid>
        );
    }

    let photographers = data ? data.photographers : [];
    let availableRegions = data ? data.availableRegions : [];

    return (
        <CalendarWithAllPhotographers
            photographers={photographers}
            user={user}
            availableRegions={availableRegions}
        />
    );
}
